import React from "react";
import VinSearchSection from "../components";
import { styles } from "./AccountDashboard.style";
import { HeadlineSection } from "./HeadlineSection";
import OverviewSection from "./OverviewSection";
import ReportSection from "./ReportSection";
import { DashboardData } from "domain/User/Common/utils/dashboard-api";
import { Container, Variant } from "@carfax/web-ui/elements/Container";

interface IAccountDashboardProps {
  dashboardData: DashboardData;
  isLoading?: boolean;
}

const AccountDashboard: React.FC<IAccountDashboardProps> = ({
  dashboardData: { activeReportsCount, expiredReportsCount, remainingCreditsCount, reports },
  isLoading = false,
}) => {
  return (
    <Container paddingTop={Variant.Top.Standard}>
      <div className={styles.root()}>
        <HeadlineSection />
        <VinSearchSection />
        <div className={styles.wrapper()}>
          <OverviewSection
            activeReportsCount={activeReportsCount}
            expiredReportsCount={expiredReportsCount}
            creditsCount={remainingCreditsCount}
            isLoading={isLoading}
          />
          <ReportSection reports={reports} isLoading={isLoading} />
        </div>
      </div>
    </Container>
  );
};

export default AccountDashboard;
